export enum ModalMode {
	DOCKED = 'docked',
	DEFAULT = 'default',
	EXPANDED = 'expanded',
}
